// components/FormComponents/FileInput.tsx
import React, { FC, useCallback, useEffect, useState } from "react";
import { DropzoneOptions, useDropzone } from "react-dropzone";
import { useFormContext, ValidationOptions } from "react-hook-form";

import "./Dropzone.scss";

import MDTrash from "react-ionicons/lib/MdTrash";

const Dropzone = (props) => {
  const [mounted, setMounted] = useState(false);

  const {
    name,
    label,
    selectedFiles,
    accept,
    setDeletedFiles,
    deletedFiles,
  } = props;
  const {
    register,
    unregister,
    setValue,
    triggerValidation,
    watch,
  } = useFormContext();
  const files = watch(name, selectedFiles);

  const onDrop = useCallback(
    (droppedFiles) => {
      setValue(name, [...files, ...droppedFiles]);
      triggerValidation(name);
    },
    [files]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
  });

  const remove = (file) => {
    if (typeof files[file] === "string")
      setDeletedFiles([...deletedFiles, files[file]]);
    const newFiles = files; // make a var for the new array
    newFiles.splice(file, 1); // remove the file from the array
    setValue(name, newFiles);
    triggerValidation(name);
  };

  useEffect(() => {
    if (register && unregister && name) register(name);
  }, [register, unregister, name]);

  return (
    <div className="dropzone-wrapper">
      <label className="mb-2 block font-bold" htmlFor={name}>
        {label}
      </label>
      <div {...getRootProps()} className="dropzone-inner border-gray-700 p-4">
        <input {...props} className="" id={name} {...getInputProps()} />
        <div className="">
          <p className="my-2 text-gray-700">Arrastra los archivos aquí</p>
          {/* Optionally you may display a preview of the file(s) */}
          {!!files?.length && (
            <div className="preview-wrapper">
              {files.map((file, index) => {
                return (
                  <div
                    key={typeof file === "string" ? file : file.name}
                    className="preview-item flex bg-white p-2 rounded-md items-center shadow-md mb-2 border-gray-400 justify-between"
                  >
                    <div className="flex items-center">
                      <img
                        className="preview-img h-16 object-cover w-auto"
                        src={
                          typeof file === "string"
                            ? file
                            : URL.createObjectURL(file)
                        }
                      />
                      <span className="ml-4 font-light text-sm">
                        {typeof file === "string"
                          ? `Archivo ${index + 1} de Firebase`
                          : file.name}
                      </span>
                    </div>
                    <span
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        remove(index);
                      }}
                      className="text-red-400 hover:text-red-700 hover:cursor-pointer mr-2 block"
                    >
                      <MDTrash className="fill-current"></MDTrash>
                    </span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dropzone;
